Bacon = require 'baconjs'
React = require 'react'
createReactClass = require 'create-react-class'
PropTypes = require 'prop-types'
cx = require 'classnames'
R = require 'ramda'

Globalize = require 'globalize'
{ FormatMessage } = require 'react-globalize'

shorten = R.compose(R.nth(0), R.split("-"))

noContact = ->
  phone: Globalize.formatMessage "restaurant.default.contact.phone"
  email: Globalize.formatMessage "restaurant.default.contact.email"
  name: Globalize.formatMessage "restaurant.default.contact.name"

Restaurant = createReactClass
  displayName: 'RestaurantInfo'

  props:
    restaurant: PropTypes.object.isRequired
    serviceId: PropTypes.string.isRequired
    orderId: PropTypes.string

  serviceContact: (restaurant) ->
    R.defaultTo(noContact(), R.path(["configuration", @props.serviceId.toLowerCase(), "contact"], restaurant))

  contactPhone: -> R.pipe(@serviceContact, R.prop('phone'))(@props.restaurant)
  contactEmail: -> R.pipe(@serviceContact, R.prop('email'))(@props.restaurant)

  render: ->
    logoClass = cx 'logo-mask', hidden: !@props.restaurant
    logoImg = R.path ['logo', 'thumb'], @props.restaurant

    <div className="panel panel-default panel-swiss">
      <div className="panel-heading">
        <FormatMessage>checkout.restaurant.intro</FormatMessage>
        <span className="visible-xs">{@props.restaurant.name}</span>
      </div>

      <div className="panel-body hidden-xs">
        <div className="restaurant-info">
          <div className={logoClass}>
            <img className="restaurant-logo" src={logoImg} alt={@props.restaurant.name} />
          </div>

          <h3>{@props.restaurant.name}</h3>
        </div>
      </div>
    </div>

module.exports = Restaurant
